<template>
 <div class="container">

<h1><font-awesome-icon icon="home" /> Home - Data - <a href="#">Application</a>
<div class="float-right">


  <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Help" ><font-awesome-icon icon="info" /></b-button>

  <b-modal id="modal-lg" size="lg" title="Data-Application Help">
   
 

  <div class="panal" v-for=" help in info" :key="help.SectionName">
   


    <div  >
      
      <div class="panal-header"> {{ help.SectionName }}</div>
     <div class="panal-body">

     <div v-html="help.SectionDescription"></div>
      </div>
     </div>

  

  </div>
      




  </b-modal>




</div>
</h1>

 

<div class="row">
  <div class="col-md-3 border-right">
    <Tap/>
  </div>
  <div class="col-md-9">
    <div class="tab-content" id="v-pills-tabContent">
      <div class="tab-pane fade show active" id="v-pills-Personal" role="tabpanel" aria-labelledby="v-pills-Personal-tab"><Personal/></div>
      <div class="tab-pane fade" id="v-pills-Contact" role="tabpanel" aria-labelledby="v-pills-Contact-tab"><Contact/></div>
      <div class="tab-pane fade" id="v-pills-Parent" role="tabpanel" aria-labelledby="v-pills-Parent-tab"> <Parent /></div>
      <div class="tab-pane fade" id="v-pills-Education" role="tabpanel" aria-labelledby="v-pills-Education-tab"><Education/></div>
      <div class="tab-pane fade" id="v-pills-Attachments" role="tabpanel" aria-labelledby="v-pills-Attachments-tab"><Attachments/></div>
      <div class="tab-pane fade" id="v-pills-Preferences" role="tabpanel" aria-labelledby="v-pills-Preferences-tab"> <Preferences :key="reviewApplication"/></div>
      <div class="tab-pane fade" id="v-pills-Terms" role="tabpanel" aria-labelledby="v-pills-Terms-tab"> <Terms/></div>
      <div class="tab-pane fade" id="v-pills-Payment" role="tabpanel" aria-labelledby="v-pills-Payment-tab"> <Payment/></div>
      <div class="tab-pane fade" id="v-pills-MyApplication" role="tabpanel" aria-labelledby="v-pills-MyApplication-tab"> <MyApplication :key="reviewApplication" /></div>
    </div>
  </div>





</div>




</div>

</template>

<script>
import Tap from "../../components/Applicant/Tap.vue";
import Preferences from "../../components/Applicant/Preferences.vue";
import Personal from "../../components/Applicant/Personal.vue";
import Parent from "../../components/Applicant/ApplicantParent.vue";
import Contact from "../../components/Applicant/Contact.vue";
import Education from "../../components/Applicant/Education.vue";
import Attachments from "../../components/Applicant/Attachments.vue";
import MyApplication from "../../components/Applicant/MyApplication.vue";
import Terms from "../../components/Applicant/Trems.vue";
import Payment from "../../components/Applicant/Payment.vue";
import ApplicantService from '../../services/Applicant/Applicant.service';
//import ApplicantService from '../services/Applicant/Applicant.service'



export default {
   components: {
      Tap,Preferences,Personal,Contact,Education,Attachments,MyApplication,Terms,Payment
      ,Parent
  
  },
  data () {
    return {
      info: '',
  
    }
  },

  mounted () {
    let id = 1;

    ApplicantService.GetHelpPages(id).then(response => {
        this.info = response.data.HelpSection
      });


  },
  computed:{
    reviewApplication(){
       return  this.$store.state.auth.renderReview 

        
       }
  }
}


</script>

<style scoped>
h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#50BD77;
}
.modal-footer {
    background: #f6f6f6 !important;
}

.panal{
  background:#eee;
  border-radius:10px;
color:#333;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;


}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}

</style>
